import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Table, Switch, message } from 'antd'
import { ColumnsType } from 'antd/lib/table'

import { IAdmin } from 'store/adminManagement/adminManagement.types'
import {
  fetchAdminsRequest,
  toggleAdminSuspendRequest
} from 'store/adminManagement/adminManagement.actions'

import styles from './AdminList.module.scss'

export const AdminList: React.FC = () => {
  const dispatch = useDispatch()
  const { admins, loading, error } = useSelector((state: any) => state.adminManagement)

  useEffect(() => {
    dispatch(fetchAdminsRequest())
  }, [dispatch])

  // Show error if it exists
  useEffect(() => {
    if (error) {
      message.error(error)
    }
  }, [error])

  const handleSuspendToggle = (adminId: string) => {
    dispatch(toggleAdminSuspendRequest(adminId))
  }

  const columns: ColumnsType<IAdmin> = [
    {
      title: 'Name',
      dataIndex: 'displayUserName',
      key: 'displayUserName'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: 'Status',
      key: 'suspended',
      render: (record: IAdmin) => (
        <Switch
          checked={!record.suspended}
          onChange={() => handleSuspendToggle(record.id)}
          checkedChildren="Active"
          unCheckedChildren="Suspended"
          loading={loading}
        />
      )
    }
  ]

  return (
    <div className={styles.root}>
      <Table
        columns={columns}
        dataSource={admins}
        loading={loading}
        rowKey="id"
        pagination={{
          pageSize: 10,
          showSizeChanger: false
        }}
      />
    </div>
  )
}
